import React from 'react';
import UnifiedOnboardingModal from '../components/onboarding/UnifiedOnboardingModal';
import { Box } from '@mui/material';
import ApplicationHeader from '../components/ApplicationHeader';
import { useAuth } from '../contexts/AuthContext';

const VERIFIER_ROLES = ['verifier', 'professional_verifier', 'quality_inspector'];

export default function VerifierApplicationPage() {
  const { user, logout } = useAuth();
  const role = VERIFIER_ROLES.includes(user?.role) ? user.role : 'verifier';
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <ApplicationHeader title="Verifier Application" onLogout={logout} />
      <UnifiedOnboardingModal userRole={role} variant="page" />
    </Box>
  );
}
